var exports = {
  "z": "xa15a2ab7--252434--root",
  "P": "xa15a2ab7--252434--label",
};

module.exports = exports;
